<template>
  <div id="select-anchor"></div>
  <div id="tooltip-anchor"></div>

  <GlobalDialogs />
  <Toast />

  <MobileMenu v-if="isMobile" />
  <SidebarMenu v-if="!isMobile" />

  <main>
    <slot />
  </main>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
import GlobalDialogs from '@/components/global/GlobalDialogs.vue';
import MobileMenu from '@/components/global/MobileMenu.vue';
import SidebarMenu from '@/components/global/SidebarMenu.vue';
import Toast from '@/components/global/Toast.vue';

const isMobile = ref(false);

const checkMobile = () => {
  const el = document.body;

  if (window.innerWidth >= 1080) {
    el.classList.remove('mobile');
    isMobile.value = false;
  } else {
    el.classList.add('mobile');
    isMobile.value = true;
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>
